import MessageIcon from 'components/atoms/icons/messageIcon';
import { useMemo } from 'react';

const useCommentButtons = ({ setPcctPopupOpen, setCommentsPopupOpen }) => {
  const commentButtons = useMemo(
    () => [
      {
        render: true,
        label: 'General Comment',
        icon: MessageIcon,
        handleClick: () => setCommentsPopupOpen(true),
      },
      {
        render: true,
        label: 'PCCT Notes Generator',
        icon: MessageIcon,
        handleClick: () => setPcctPopupOpen(true),
      },
    ],
    [setPcctPopupOpen, setCommentsPopupOpen],
  );

  return commentButtons;
};

export default useCommentButtons;
